// PRD 08 §10.3 — prerequisite drill-down rail.
//
// In split mode this renders as a sibling column. In left/right mode it
// portals over the main Rail (overlay). The actual drill-stack feature
// lands with the Definition-model migration (task #9 — adds the
// prerequisites: list[term_id] DAG); this is the structural shell that
// makes the three rail-position modes wire-able without the data layer.

import type { ReactNode } from "react";

export interface DrillRailProps {
  // Render mode chosen by ReadingPage; controls portal vs inline.
  mode: "left" | "right" | "split";
  // Empty state hint text, swapped in once drill-stack data arrives.
  children?: ReactNode;
}

export function DrillRail({ mode, children }: DrillRailProps) {
  // Split: inline sibling column.
  if (mode === "split") {
    return (
      <aside className="maisight-drillrail" aria-label="Prerequisites">
        {children ?? (
          <p className="maisight-drillrail-empty">
            Hover a term to see prerequisites.
          </p>
        )}
      </aside>
    );
  }
  // left / right: nothing inline; overlay path lands with the drill stack.
  return null;
}
